import { computed, Injectable, signal, TemplateRef, ViewContainerRef } from '@angular/core';
import { Portal, TemplatePortal } from '@angular/cdk/portal';

@Injectable({
  providedIn: 'root'
})
export class NavbarPortalService {
    private vcr: ViewContainerRef | null = null;
    private _portal = signal<Portal<unknown> | null>(null);

    readonly portal = computed(() => this._portal());

    setViewContainerRef(vcr: ViewContainerRef) {
        this.vcr = vcr;
    }

    setTemplate(template: TemplateRef<unknown>) {
        if (!this.vcr) throw new Error('VCR not set');
        this._portal.set(new TemplatePortal(template, this.vcr));
    }

    clear() {
        this._portal.set(null);
    }
}
